import type { FunctionComponent, ReactNode } from 'react'
import React from 'react'
import { Button } from '@which/seatbelt'

import classnames from 'classnames'

import styles from './SkipButton.module.scss'

export const SkipButton: FunctionComponent<SkipButtonProps> = ({
  className,
  children,
  selector,
}) => {
  const shiftFocusToElement = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const element = document.querySelector(selector) as HTMLElement

    if (element) {
      const prevTabIndex = element.getAttribute('tabindex')
      // Temporarily set tabindex to enable element to be programatically focused
      // and so it can be announced by screen readers
      element.setAttribute('tabindex', '-1')
      element?.focus()

      element.addEventListener('blur', () => {
        prevTabIndex
          ? element.setAttribute('tabindex', prevTabIndex)
          : element.removeAttribute('tabindex')
      })
    }
  }
  return (
    <Button
      appearance="secondary"
      className={classnames(styles.skipButton, className)}
      onClick={shiftFocusToElement}
      onKeyDown={(e) => e.key === 'Enter' && shiftFocusToElement(e)}
    >
      {children}
    </Button>
  )
}

type SkipButtonProps = {
  className?: string
  children: ReactNode
  selector: string
}
